import { useState, type PropsWithChildren } from "react";

interface AccordionCardProps extends PropsWithChildren {
  title: string;
  defaultOpen?: boolean;
}

function AccordionCard({
  title,
  defaultOpen = true,
  children,
}: AccordionCardProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <section>
      <button
        type="button"
        className="accordion-trigger"
        onClick={() => setOpen((prev) => !prev)}
      >
        <span>{title}</span>

        <span
          className={`accordion-icon ${
            open ? "accordion-icon--open" : ""
          }`}
        >
          ▼
        </span>
      </button>

      {open && (
        <div className="accordion-content">
          {children}
        </div>
      )}
    </section>
  );
}

export default AccordionCard;